import React from "react";
import {Button, Tooltip} from "antd";
import {EditOutlined} from "@ant-design/icons";
import Authorize from "../../../Authorize";
import {EDIT_DECLARANT} from "../../../../constants/authorize";
import {DEPARTMENT_DATA_SERVICES} from "../../../../constants/translates";
import {useExecuteModal} from "../../../../hooks/useExecuteModal";
import {DepartmentDataService} from "../../../../models/DepartmentData/DepartmentDataService";
import {getDepartmentDataStore} from "../../../../stores/containers/DepartmentDataStore.container";
import DepartmentDataServicesModal from "../../../modals/departmentData/DeparmentDataServicesModal/DepartmentDataServicesModal";

type EditServicesButtonProps = {
  groupId: string;
  services: DepartmentDataService[];
};

const EditServicesButton = ({ groupId, services }: EditServicesButtonProps) => {
  const modalHandler = useExecuteModal();

  return (
    <Authorize permission={EDIT_DECLARANT}>
      <>
        <Tooltip title={DEPARTMENT_DATA_SERVICES.edit}>
          <Button
            type="link"
            aria-label={DEPARTMENT_DATA_SERVICES.edit}
            onClick={modalHandler.executeModal}
          >
            <EditOutlined />
          </Button>
        </Tooltip>
        <DepartmentDataServicesModal
          groupId={groupId}
          handler={modalHandler}
          store={getDepartmentDataStore()}
          initialServices={services}
        />
      </>
    </Authorize>
  );
};

export default EditServicesButton;
